<template>
  <Modal class="my-modal" v-model="visible" :footer-hide="true" :mask-closable="false" :title="title" width="600">
    <Form v-if="visible" ref="form" :model="formInline" :rules="ruleInline" :label-width="100">
      <FormItem prop="addCode" label="附加险code">
        <Input type="text" v-model="formInline.addCode" placeholder="输入附加险code" maxlength="14" :disabled="editType != 1"></Input>
      </FormItem>
      <FormItem prop="addName" label="附加险名称">
        <Input type="text" v-model="formInline.addName" placeholder="输入附加险名称"></Input>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="confirmAdd" :loading="loading">提交</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ['gradeAdditions', 'additionals', 'productCode'],
  mixins: [],
  components: {},
  data() {
    return {
      formInline: { addCode: '', addName: '', type: '1' },
      visible: false,
      selIndex: '',
      loading: false,
      title: '',
      ruleInline: {
        addCode: [
          {
            required: true,
            message: '请输入档次/计划编号',
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入附加险code'));
              } else {
                const code = this.formInline.addCode;
                if (this.additionals && this.additionals.length) {
                  // 检测当前附加险code是否与其余重复
                  let lth = this.additionals.filter(i => i.addCode == code).length;
                  let idx = this.additionals.findIndex(i => i.addCode == code);
                  if (
                    (this.editType == 1 && lth != 0) ||
                    (this.editType == 2 && (lth > 1 || (idx != -1 && idx != this.selIndex))) ||
                    (this.productCode && code == this.productCode.trim())
                  ) {
                    callback(new Error('产品code已存在，请重新录入'));
                  }
                } 
                if (this.gradeAdditions && this.gradeAdditions.length) {
                  let lth = this.gradeAdditions.filter(i => i.gradeCode == code).length;
                  if(lth) {
                    callback(new Error('档次/计划已存在此编码，请重新录入'));
                  }
                }
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        addName: {
          required: true,
          message: '请输入附加险名称'
        }
      }
    };
  },
  created() {},
  methods: {
    open(row = {}, editType, index = null) {
      this.loading = false;
      this.title = editType == 1 ? '新增附加险' : '编辑附加险';
      this.editType = editType;
      this.selIndex = index;
      let data = JSON.parse(JSON.stringify(row));
      if (data.addCode) {
        this.formInline = data;
      } else {
        this.formInline = { addCode: '', addName: '', type: '1' };
      }
      this.visible = true;
    },
    confirmAdd() {
      this.loading = true;
      //新增附加险
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          this.loading = false;
          return;
        }
        if (this.formInline.addCode == '00') {
          this.$notice.error('00编号不可用');
          return;
        }
        this.$emit('success', this.editType, this.formInline, this.selIndex);
        this.visible = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
// .my-modal {
//     /deep/ {
//         .ivu-checkbox-inner {
//             top: -1px;
//         }

//         .ivu-checkbox-group-item {
//             width: 25%;
//             margin-right: 0;
//         }
//     }
// }
/deep/.ivu-modal-body {
  margin-top: 20px;
}

.tab-box {
  position: relative;
  margin-bottom: 10px;

  .tab-name {
    position: absolute;
    left: 0;
    top: 11px;
    z-index: 1;
    font-size: 14px;
    font-weight: bold;
  }

  /deep/ {
    .ivu-tabs-nav {
      padding-left: 120px;
    }
  }
}
</style>
